import { useCallback, useMemo } from 'react'

import { useApiQuery } from 'admin/lib/Api'
import { ModuleLabels } from './constants'

export function useContextLoader(accountId, projectId, moduleName) {
  const account = useApiQuery(
    useCallback(api => api.getAccount(accountId), [accountId])
  )
  const project = useApiQuery(
    useCallback(
      api => api.getProject(accountId, projectId),
      [accountId, projectId]
    )
  )

  const context = useMemo(() => {
    return {
      loaded: account.loaded && project.loaded,
      error: account.error ?? project.error,
      account: account.data,
      project: project.data,
      module: ModuleLabels[moduleName.toLowerCase()] ?? ModuleLabels.default
    }
  }, [
    account.loaded,
    account.error,
    account.data,
    project.loaded,
    project.error,
    project.data,
    moduleName
  ])

  return context
}
